
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Company } from '@/models/company';
import moment from 'moment';

@Component({
    name: 'ExportLayout',
    components: {},
})
export default class ExportLayout extends Vue {
    @Prop({
        required: true,
    })
    title: string;

    @Prop({
        required: false,
    })
    descriptions: string[];

    // noinspection JSUnusedGlobalSymbols
    canExportToCsv = false;

    @Getter('account/company') private company: Company;

    get currentDate() {
        return moment();
    }

    mounted() {
        let printCalled = false;
        const logoLoaded = () => {
            if (printCalled) {
                return;
            }
            printCalled = true;
            setTimeout(() => window.print(), 100);
        };

        const img = document.getElementById('currentLogo') as HTMLImageElement;
        if (!img) {
            // Default wait time in case no logo exists
            setTimeout(() => {
                logoLoaded();
            }, 500);
            return;
        }

        // Fallback if the image doesn't load or error
        setTimeout(() => {
            logoLoaded();
        }, 4000);

        if (img.complete) {
            logoLoaded();
        } else {
            img.addEventListener('load', logoLoaded);
            img.addEventListener('error', logoLoaded);
        }
    }
}
